import styled from 'styled-components';
import { Platform } from 'sofa-reborn-react';
export const Div = styled.div<{
	platform: Platform;
	show: boolean;
	sceneHeight: number;
}>`
	display: flex;
	max-width: 100%;
	max-height: ${(props) => (props.platform === 'kiosk' ? '100vw' : props.sceneHeight + 'px')};
	flex-direction: row;
	flex-grow: 1;
	flex-shrink: 1;
	flex-basis: auto;
	visibility: ${(props) => (props.show ? 'visible' : 'hidden')};
	overflow: hidden;
`;

export const DebugLayer = styled.div`
	height: 100%;
`;
